import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { useConsultation } from './ConsultationContext';
export function HeroSection() {
  const {
    openModal
  } = useConsultation();
  return <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden" data-id="element-160">
      {/* Parallax Background using CSS gradient to simulate dewy glass skin texture */}
      <div className="absolute inset-0 z-0 bg-fixed" style={{
      background: 'radial-gradient(circle at 70% 30%, rgba(250, 248, 245, 1) 0%, rgba(242, 239, 233, 0.8) 40%, rgba(155, 181, 162, 0.15) 100%)'
    }} data-id="element-161">
        {/* Subtle texture overlay */}
        <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
      }} data-id="element-162"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 py-12 md:py-24" data-id="element-163">
        <div className="max-w-3xl mx-auto text-center" data-id="element-164">
          <FadeIn delay={100} data-id="element-165">
            <span className="inline-block font-sans font-semibold text-jade tracking-[0.2em] uppercase text-xs md:text-sm mb-6" data-id="element-166">
              Korean Mesotherapy · Be Clinical San Ramon
            </span>
          </FadeIn>

          <FadeIn delay={300} data-id="element-167">
            <h1 className="text-[32px] md:text-5xl lg:text-6xl font-serif leading-[1.15] text-primary mb-8" data-id="element-168">
              Glass Skin Isn't a Filter.
              <br data-id="element-169" />
              <span className="italic text-primary/90" data-id="element-170">
                It's What Happens When Your Skin Gets What It Needs.
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={500} data-id="element-171">
            <p className="text-base md:text-lg text-foreground/80 leading-relaxed max-w-2xl mx-auto mb-10 font-sans" data-id="element-172">
              Korean Mesotherapy delivers a custom cocktail of vitamins,
              peptides, and hyaluronic acid directly into the skin's middle
              layer — feeding your cells what they need to hydrate, firm, and
              glow from within.
            </p>
          </FadeIn>

          <FadeIn delay={700} data-id="element-173">
            <Button className="md:w-auto w-full text-sm md:text-base px-10" onClick={openModal} data-id="element-174">
              Book Your Free Consultation
            </Button>
          </FadeIn>

          <FadeIn delay={900} data-id="element-175">
            <div className="flex flex-col items-center gap-2 mt-6" data-id="element-176">
              <div className="flex items-center gap-0.5" data-id="element-177">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-178">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-179" />
                  </svg>)}
              </div>
              <p className="text-sm text-foreground/60 tracking-wide" data-id="element-180">
                250+ Reviews · 4.9 Stars · San Ramon, CA
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}